<template>
  <div class="g_page">
    <div class="navBarHeight" :style="{height:nHeight+'px'}">
      <div id="navBar">
        <div class="banner" :class="bannerHideFlag?'hide':''">
          <img src="../../images/h_bg.jpg" class="b_bg" />
          <span class="icon-close" @click="bannerHide"></span>
        </div>
        <div class="tab">
          <div class="tab_cell" :class="tabIndex==1?'selected':''" @click="getDataIndex(1)">全部</div>
          <div class="tab_cell" :class="tabIndex==2?'selected':''" @click="getDataIndex(2)">最新</div>
          <div class="tab_cell" :class="tabIndex==3?'selected':''" @click="getDataIndex(3)">最优惠</div>
          <div class="tab_cell" :class="tabIndex==4?'selected':''" @click="getDataIndex(4)">销量</div>
        </div>
      </div>
    </div>
    <div class="coupon_goods_list_wrapper">
      <ul class="coupon_goods_list_ul" >
        <router-link :to="{ name: 'item', params: { id: dataList.id }}" v-for="(dataList,index) in dataLists" :key="dataList.id" class="coupon_goods_list_li">
          <div class="li_top">
            <img :src="dataList.goodsPic" class="goods_pic"/>
            <p v-if="index==0" class="left_coupon">还剩{{dataList.couponReserve
}} 张券</p>
          </div>
          <div class="li_btm">
            <p class="goods_title">{{dataList.goodsName}}</p>
            <p class="goods_shop">
              <img src="../../images/tmallSelected.png"  v-if="dataList.mallType=='天猫'" class='n_goods_shop_img'/>
              <img src="../../images/taobao.png"  v-if="dataList.mallType!='天猫'" class='n_goods_shop_img' />
              <img src="../../images/haitao.png"  v-if="dataList.isHaiTao==1" class='n_goods_shop_img' />
              <img src="../../images/juhuasuan.png"  v-if="dataList.isJuHuaSuan==1" class='n_goods_shop_img' />
              <img src="../../images/taoqianggou.png"  v-if="dataList.isTaoQiangGou==1" class='n_goods_shop_img' />
              <img src="../../images/video.png"  v-if="dataList.isVideo==1" class='n_goods_shop_img'/>{{dataList.shopName}}</p>
            <div class="goods_coupon">
              <span class="goods_coupon_l">领券直降</span><img src="../../images/jrqg_coupon_bg.png" class="goods_coupon_c" /><span class="goods_coupon_r">￥{{dataList.money
  }}</span>
            </div>
            <div class="goods_money">
              <span class="goods_money_l"><span class="s1">券后</span><span class="s2">￥{{dataList.finalPrice}}</span></span>
              <span class="goods_money_r">原价￥{{dataList.price}}</span>
            </div>
          </div>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
import $ from 'jquery'
import { Indicator } from 'mint-ui' //提示搜索优惠券
  export default{
    name:"hot",
    data(){
      return {
        bannerHideFlag:false,
        tabIndex:1,
        url:'',
        dataLists:[],
        page:1,
        loading:false,
        order:"addTime",
        catalog:"热销榜",
        keyword:'isHot',
        REQUIRE:false,
        navBarFixed:false,
        offsetTop:0,
        nHeight:0,
      }
    },
    methods:{
      bannerHide:function(){
        this.bannerHideFlag = !this.bannerHideFlag
        this.$nextTick(()=>{
          this.offsetTop = document.querySelector('#navBar').offsetTop
          this.nHeight = $('#navBar').height()
        })
      },
      getDataIndex:function(type){
        this.loading=false
        this.REQUIRE = false
        switch (type) {
          case 1:
            this.tabIndex=1
            this.order = 'addTime'
            this.page=1
            this.dataLists = []
            this.login()
            break;
          case 2:
            this.tabIndex=2
            this.order = 'addTime'
            this.page=1
            this.dataLists = []
            this.login()
            break;
          case 3:
            this.tabIndex=3
            this.order = 'money/price'
            this.page=1
            this.dataLists = []
            this.login()
            break;
          case 4:
            this.tabIndex=4
            this.order = 'sells'
            this.page=1
            this.dataLists = []
            this.login()
            break;
          default:
            this.tabIndex=1
            this.login()

        }
      },
     /*axios调用数据*/
      login () {
        this.url = "api/getGoods.php?page="+this.page+"&pageSize=10&order="+this.order+"&searchType=goodsMenu&catalog=" +this.catalog+"&keyword="+this.keyword
            console.log(this.url )
            this.$ajax.autoService
                .login(this.url)
                .then((res) => {
                  this.dataLists = this.dataLists.concat(res.data.map(function(item){
                    item.finalPrice = (item.price - item.money).toFixed(2);
                    item.coupon_price = parseInt(item.coupon_price)
                    item.goodsName = item.goodsName.slice(0,36)
                    var temp = item.goodsPic
                    temp = temp.replace('https:', '')
                    temp = temp.replace('http:', '')
                    item.goodsPic = "https:" + temp
                    return item
                  }))
                  //this.loading = false
                  this.$nextTick(() => {
                    this.REQUIRE = true;
                    this.loading = false;
                    Indicator.close()
                  });
                  //console.log(this.dataLists)
                }, (res) => {
                    console.log("error")
                    this.REQUIRE = true;
                })
           },
           /*axios向下加载*/
           scrollBottom() {

               this.offsetTop = document.querySelector('#navBar').offsetTop
            // 滚动到页面底部时，请求前一天的文章内容
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

             if (scrollTop > this.offsetTop) {
                this.navBarFixed = true
              } else {
                this.navBarFixed = false
              }

              if (((window.screen.height + scrollTop) > (document.body.clientHeight)-10)&& this.REQUIRE){
              // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
              this.REQUIRE = false;
              this.loading = true;
              this.tips = '努力加载中...';
              this.page+=1
              this.login(this.url)
              Indicator.open('正在加载优惠券');

        }
      }
    },
    created (){
     this.login(this.url)


    },
    mounted(){
      this.offsetTop = document.querySelector('#navBar').offsetTop
       window.addEventListener('scroll', this.scrollBottom)
       this.nHeight = $('#navBar').height()
    },
    beforeDestroy(){
      Indicator.close()
    },
    computed:{

    }
  }
</script>
<style lang="stylus">
.g_page
  #navBar
    width:100%
    position:fixed
    left:0px
    top:0px
    z-index:999
    .banner
      width:100%
      height:120px
      position:relative
      &.hide
        display:none
      .b_bg
        width:100%
        height:120px
        display:block
      .icon-close
        width:40px
        height:40px
        border-radius:20px
        background:rgba(0,0,0,0.3)
        color:#fff
        font-size:20px
        position:absolute
        right:10px
        top:10px
        line-height:40px
        text-align:center
        font-weight:bold
    .tab
      padding:0 35px
      box-sizing:border-box
      height:80px
      display:flex
      align-items:center
      background:#fff
      .tab_cell
        flex:1
        text-align:center
        font-size:28px
        color:#353535
        &.selected
          color:#000

</style>



// WEBPACK FOOTER //
// src/components/goodsNav/hot.vue